module.exports = __webpack_public_path__ + "static/fonts/DB Heavent UlLi v3.2.48772bd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DB Heavent/DB Heavent UlLi v3.2.ttf
// module id = eCf6
// module chunks = 1